(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockAngebotProduktinfos', {
            bindings: {
                angebotModel: '<abapAngebotModel',
                produktinfos: '<abapProduktinfos',
                toggleOpen: '&abapToggleOpen',
                isOpen: '<abapIsOpen',
                form: '<abapForm',
                options: '<abapOptions'
            },
            templateUrl: 'bloecke/angebotproduktinfos/blockAngebotProduktinfos.html',
            controller: BlockAngebotProduktinfosController,
            controllerAs: 'blockAngebotProduktinfosVm'
        });

    BlockAngebotProduktinfosController.$inject = [
        '$log',
        '$scope',
        '$timeout',
        '$q',
        '$modal',
        '$analytics',
        '$element',
        'lodash',
        'mediaQueries',
        'AppConfig',
        'BasisAngebotService',
        'FilecacheService',
        'FormatUtilsService',
        'MiscUtilsService',
        'LoadingIndicatorService',
        'WaitOverlayService',
        'BinaryUtilsService',
        'FormFieldUtilsService',
        'NavigationService'
    ];
    function BlockAngebotProduktinfosController($log, $scope, $timeout, $q, $modal, $analytics, $element, _, mediaQueries, AppConfig, BasisAngebotService, FilecacheService, FormatUtilsService, MiscUtilsService, LoadingIndicatorService, WaitOverlayService, BinaryUtilsService, FormFieldUtilsService, NavigationService) {
        var vm = this,
            origIsBlockOpen,
            angebotsnummerFormatiert,
            angebotPdfName,
            druckwege = AppConfig.ANGEBOT.druckwege;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;
        vm.$doCheck = doCheck;

        vm.isAngebotAenderbar = isAngebotAenderbar;
        vm.hasPostDruckweg = hasPostDruckweg;
        vm.isVorschauDirektdruckErlaubt = isVorschauDirektdruckErlaubt;
        vm.isEmailDirektdruckErlaubt = isEmailDirektdruckErlaubt;
        vm.isBlockEmailDirektdruckErlaubt = isBlockEmailDirektdruckErlaubt;
        vm.starteDirektdruckVoransicht = starteDirektdruckVoransicht;
        vm.navigateToReiterUnterlagen = navigateToReiterUnterlagen;
        vm.toggleBlockEmailDirektdruck = toggleBlockEmailDirektdruck;
        vm.onOpen = onOpen;
        vm.onClose = onClose;
        vm.startDirektdruck = startDirektdruck;

        function activate() {
            vm.options = vm.options || {};

            angebotsnummerFormatiert = BasisAngebotService.getAngebotsnummer(vm.angebotModel.angebot, true);
            angebotPdfName = FormatUtilsService.replace(AppConfig.ANGEBOT.pdfNames.angebot.name, angebotsnummerFormatiert);
            vm.isBlockOpen = vm.isOpen;
            vm.angebotPdf = null;
            vm.isAppModus = MiscUtilsService.isAppModus();
            vm.isDruckwegeErlaubt = MiscUtilsService.isNotEmpty(druckwege) && !vm.options.druckenDisabled;
        }

        function onInit() {
            vm.isBlockOpen = origIsBlockOpen = false;
            vm.linkBtnDescAngebotDrucken = 'Tarifauskunft drucken';
            vm.linkBtnDescAngebotEmailZusenden = 'Tarifauskunft per E-Mail zusenden';
            vm.linkBtnDescAngebotPostZusenden = 'Tarifauskunft per Post zusenden';
            vm.linkBtnDescAngebotZusenden = hasPostDruckweg() ? 'Tarifauskunft zusenden' : vm.linkBtnDescAngebotEmailZusenden;
            activate();
        }

        function onChanges() {
            activate();
        }

        function doCheck() {
            if (vm.options.mqVisible) {
                if (!_.some(_.split(vm.options.mqVisible, ','), function (mediqQueryName) {
                    if (mediaQueries[mediqQueryName] && _.isFunction(mediaQueries[mediqQueryName])) {
                        return mediaQueries[mediqQueryName]();
                    }
                })) {
                    vm.blockEmailDirektdruckSichtbar = false;
                }
            }

            vm.angebotPdf = FilecacheService.getFile(angebotPdfName, 'report');

            if (vm.angebotPdf && BasisAngebotService.hatAenderungen(vm.angebotModel.angebot, vm.angebotModel.angebotLetzterDruck)) {
                vm.angebotPdf = FilecacheService.removeFile(angebotPdfName, 'report');
            }

            if (origIsBlockOpen !== vm.isBlockOpen) {
                origIsBlockOpen = vm.isBlockOpen;

                if (!vm.isBlockOpen) {
                    vm.blockEmailDirektdruckSichtbar = false;
                }

                vm.toggleOpen({
                    open: vm.isBlockOpen
                });
            }
        }
        function hasPostDruckweg() {
            return _.hasIn(druckwege, 'post');
        }
        function isAngebotAenderbar(type) {
            return BasisAngebotService.isAngebotAenderbar(vm.angebotModel.angebot, type);
        }
        function isVorschauDirektdruckErlaubt() {
            return AppConfig.ANGEBOT.druckwegVorschauDirektdruck === true;
        }
        function isEmailDirektdruckErlaubt() {
            return AppConfig.ANGEBOT.druckwegEmailDirektdruck === true;
        }
        function isBlockEmailDirektdruckErlaubt() {
            return (
                isEmailDirektdruckErlaubt() &&
                vm.blockEmailDirektdruckSichtbar === true
            );
        }
        function starteDirektdruckVoransicht() {
            vm.blockEmailDirektdruckSichtbar = false;
            $timeout(function () {
                startDirektdruck(_.get(druckwege, 'vorschau.wert'));
            }, 0);
        }
        function navigateToReiterUnterlagen(druckweg) {
            vm.blockEmailDirektdruckSichtbar = false;
            $timeout(function () {
                NavigationService.goToStep('rechner.unterlagen', {
                    druckweg: druckweg,
                    formValidation: true,
                    ignoreFollowingCheck: true
                });
            }, 0);
        }

        function toggleBlockEmailDirektdruck(open) {
            if (open) {
                vm.blockEmailDirektdruckSichtbar = true;
            } else {
                $timeout(function () {
                    vm.blockEmailDirektdruckSichtbar = false;
                });
            }
        }

        function onOpen() {
            if (vm.accordionIsOpen !== undefined) {
                $analytics.eventTrack('accordion', {
                    trackingProvider: 'wgv',
                    target: 'unterlagen_anfordern',
                    value: 'open'
                });
            }

            vm.accordionIsOpen = true;
        }

        function onClose() {
            if (vm.accordionIsOpen !== undefined) {
                $analytics.eventTrack('accordion', {
                    trackingProvider: 'wgv',
                    target: 'unterlagen_anfordern',
                    value: 'close'
                });
            }

            vm.accordionIsOpen = false;
        }
        function startDirektdruck(druckweg) {
            var angebotPdf = AppConfig.ANGEBOT.pdfNames.angebot,
                deferred,
                pdfLoadedDeferred,
                modalPdfViewer,
                cachedFile,
                overlay,
                focusElementAfterCloseModal = $element[0].querySelector('.btn-' + druckweg + ' a');

            FormFieldUtilsService.validate(vm.form, '$$controls', {
                setTouched: true,
                setIsSubmitted: true
            });

            if (!vm.form.$valid) {
                return;
            }

            $scope.$emit('iplusjs:removeAlert', {
                reason: 'ERROR'
            });

            BasisAngebotService.uebernehmeAngebotspartner(vm.angebotModel.angebot, 'antragsteller', 'postempfaenger');

            if (druckweg === _.get(druckwege, 'vorschau.wert')) {
                if (!MiscUtilsService.isPdfjsViewerEnabled()) {
                    vm.waitOverlay = {
                        url: AppConfig.ANGEBOT.waitHelperUrl,
                        options: {
                            id: 'wgv',
                            logo: 'wgv_logo.svg',
                            message: AppConfig.MESSAGES.druckenPopup,
                            popupName: angebotPdf.bezeichnung,
                            popupWidth: 720,
                            popupHeight: 610,
                            showLoading: true
                        }
                    };
                } else {
                    deferred = $q.defer();
                    pdfLoadedDeferred = $q.defer();

                    modalPdfViewer = $modal.open({
                        templateUrl: 'modal/modalPdfViewer.html',
                        windowClass: 'xlarge pdfjs',
                        controller: 'ModalPdfViewerController',
                        controllerAs: 'modalVm',
                        resolve: { /* @ngInject */
                            pdf: [function () {
                                return deferred.promise;
                            }]
                        }
                    });

                    modalPdfViewer.result.then(function () {
                        focusElementAfterCloseModal && focusElementAfterCloseModal.focus();
                    }).catch(function (error) {
                        focusElementAfterCloseModal && focusElementAfterCloseModal.focus();
                    });

                    deferred.resolve(pdfLoadedDeferred);
                }
            } else {
                LoadingIndicatorService.addInProgress();
            }

            BasisAngebotService.speichere(vm.angebotModel).then(function (data) {
                $log.debug('speichere SUCCESS');

                if (data.angebot) {
                    vm.angebotModel.angebot = angular.merge({}, data.angebot);
                }

                BasisAngebotService.validiere({
                    tarifkuerzel: vm.angebotModel.tarif.tarifkuerzel,
                    angebot: vm.angebotModel.angebot,
                    formData: vm.angebotModel.formData,
                    stufe: 'ANGEBOTSDRUCK_START'
                }).then(function () {
                    BasisAngebotService.angebotDrucken(vm.angebotModel, druckweg).then(function (data) {
                        $log.debug('angebotDrucken SUCCESS', data);

                        if (druckweg === _.get(druckwege, 'vorschau.wert')) {
                            if (!MiscUtilsService.isPdfjsViewerEnabled()) {
                                overlay = WaitOverlayService.get();
                            }

                            BinaryUtilsService.convertBinaryToFile(data.binary, 'pdf').then(function (file) {
                                cachedFile = FilecacheService.addFile({
                                    name: FormatUtilsService.replace(angebotPdf.name, BasisAngebotService.getAngebotsnummer(vm.angebotModel.angebot, true)),
                                    type: 'report',
                                    bezeichnung: angebotPdf.bezeichnung,
                                    blobUrl: file.blobUrl,
                                    blob: file.blob,
                                    filename: data.filename
                                });

                                if (!MiscUtilsService.isPdfjsViewerEnabled()) {
                                    $scope.$emit('iplusjs:openFile', cachedFile, overlay.popup);
                                    WaitOverlayService.close(false);
                                } else if (pdfLoadedDeferred) {
                                    pdfLoadedDeferred.resolve(cachedFile);
                                }
                            }).catch(function (error) {
                                if (!MiscUtilsService.isPdfjsViewerEnabled()) {
                                    WaitOverlayService.close();
                                } else if (pdfLoadedDeferred) {
                                    pdfLoadedDeferred.reject();
                                }
                            });
                        } else {
                            $scope.$emit('iplusjs:createAndAddAlert', {
                                message: FormatUtilsService.replace(AppConfig.MESSAGES.angebotDruckPostEmail, FormatUtilsService.joinArrayByCondition(['Post', 'E-Mail'], [druckweg === _.get(druckwege, 'post.wert'), druckweg === _.get(druckwege, 'email.wert')])),
                                type: 'info'
                            });

                            vm.blockEmailDirektdruckSichtbar = false;

                            LoadingIndicatorService.removeInProgress();
                        }
                    }).catch(function (error) {
                        $log.debug('angebotDrucken FAILURE', error);

                        LoadingIndicatorService.removeInProgress();

                        if (!MiscUtilsService.isPdfjsViewerEnabled()) {
                            WaitOverlayService.close();
                        } else if (pdfLoadedDeferred) {
                            pdfLoadedDeferred.reject();
                        }
                    });
                }).catch(function (error) {
                    $log.debug('validiere FAILURE', error);

                    LoadingIndicatorService.removeInProgress();

                    if (!MiscUtilsService.isPdfjsViewerEnabled()) {
                        WaitOverlayService.close();
                    } else if (pdfLoadedDeferred) {
                        pdfLoadedDeferred.reject();
                    }
                });

            }).catch(function (error) {
                $log.debug('speichere FAILURE', error);

                LoadingIndicatorService.removeInProgress();

                if (!MiscUtilsService.isPdfjsViewerEnabled()) {
                    WaitOverlayService.close();
                } else if (pdfLoadedDeferred) {
                    pdfLoadedDeferred.reject();
                }
            });
        }
    }

})();
